import { createFileRoute, Outlet } from '@tanstack/react-router';

import { createQueryCheckoutAllowed } from 'src/api/queries';
import { AppPage } from 'src/components/AppPage';

export const Route = createFileRoute('/_auth/_only-header/store/dm-offer')({
  async loader({ context }) {
    await context.queryClient.ensureQueryData(createQueryCheckoutAllowed());
  },
  component: () => (
    <AppPage.Container>
      <Outlet />
    </AppPage.Container>
  ),
});
